import React, { useState, useContext } from "react";
import { useHistory } from "react-router-dom";

import { Avatar, Button } from "@material-ui/core";

import { UserContext } from "../../AppRouter";

import "../../../styles/pages/Widgets/Follow.css";

const Follow = ({ followUser, handleProfileView, handleFollow }) => {
  const [user] = useContext(UserContext);
  const history = useHistory();
  const [showUserCard, setShowUserCard] = useState(false);

  return (
    <div className="follow">
      <div className="follow__left">
        <Avatar
          src={followUser.avatar.url}
          className="follow__Avatar"
          onClick={() => handleProfileView(followUser.username)}
        />
        <div
          className="follow__names"
          onClick={() => handleProfileView(followUser.username)}
          onMouseEnter={() => setShowUserCard(true)}
          onMouseLeave={() => setShowUserCard(false)}
        >
          <div
            className="follow__userCard"
            style={{
              visibility: showUserCard ? "visible" : "hidden",
              opacity: showUserCard ? 1 : 0,
            }}
          >
            <div className="userCard__header">
              <Button
                className="userCard__AvatarButton"
                onClick={() => history.push(`/${followUser.username}`)}
              >
                <Avatar
                  className="userCard__Avatar"
                  src={followUser.avatar.url}
                />
              </Button>
              {user.user._id !== user._id && (
                <Button
                  className="userCard__followButton"
                  onClick={() => handleFollow(followUser)}
                >
                  {user.user.following
                    .map((following) => following)
                    .indexOf(user._id) !== -1
                    ? "Following"
                    : "Follow"}
                </Button>
              )}
            </div>
            <div className="userCard__body">
              <div className="userCard__topBody">
                <div
                  className="userCard__names"
                  onClick={() => history.push(`/${followUser.username}`)}
                >
                  <h5 className="userCard__name">{followUser.name}</h5>
                  <h5 className="userCard__username">@{followUser.username}</h5>
                </div>
                {user.user.followers
                  .map((follower) => follower._id)
                  .indexOf(user._id) !== -1 && (
                  <h5 className="userCard__followsYou">Follows you</h5>
                )}
              </div>
              <div className="userCard__botBody">
                <h5 className="userCard__bio">{followUser.bio}</h5>
                <div className="userCard__followStats">
                  <h5 className="userCard__following">
                    {followUser.following.length}{" "}
                    <span className="userCard__followText">Following</span>
                  </h5>
                  <h5 className="userCard__followers">
                    {followUser.followers.length}{" "}
                    <span className="userCard__followText">Followers</span>
                  </h5>
                </div>
              </div>
            </div>
          </div>

          <h5 className="follow__name">{followUser.name}</h5>
          <h5 className="follow__username">@{followUser.username}</h5>
        </div>
      </div>
      <Button
        className="follow__Button"
        onClick={() => handleFollow(followUser)}
      >
        Follow
      </Button>
    </div>
  );
};

export default Follow;
